type Payload = {
  statisticsType: string,
  filter: {[filterName: string]: any},
};

const initialState = {
  entities: {},
};

const statisticsFiltersReducer = (state = initialState, action: {type: string, payload: Payload}) => {
  switch (action.type) {
    case 'HANDLE_STATISTICS_FILTER_SELECTED': {
      const {statisticsType, filter} = action.payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [statisticsType]: {
            ...state.entities[statisticsType],
            ...filter,
          }
        }
      }
    }
    default:
      return state;
  }
};

export default statisticsFiltersReducer;
